import { useMutation } from '@apollo/client';
import { REGENERATE_SECRET } from './mutation';
export function useRegenerateSecret() {
    const [mutate, { loading, error, data }] = useMutation(REGENERATE_SECRET);
    const regenerateSecret = (id) => mutate({ variables: { id } });
    return { regenerateSecret, loading, error, data: data === null || data === void 0 ? void 0 : data.regenerateWebApiClient };
}
